import { PageAction } from './../models/page-config';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { BaseService } from 'src/app/core/services/base.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-data-import-dialog',
  templateUrl: './data-import-dialog.component.html',
  styleUrls: ['./data-import-dialog.component.scss']
})
export class DataImportDialogComponent implements OnInit {
  @ViewChild(DynamicFormComponent) dynamicFormComponent;
  @ViewChild('fileInput') fileInput: ElementRef;

  tableConfig: any;
  tableData: any[];

  willDownload = false;

  constructor(
    private baseService: BaseService,
    private dialogRef: MatDialogRef<DataImportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      configProc: string,
      contentProc: string,
      actionProc: string,
      dialogTitle: string,
      action: PageAction,
      additionalData: any
    }) { }

  async ngOnInit(): Promise<void> {
    const tableConfigResponse = await this.baseService.executeCommand<any>(this.data.action.actionData.configProc, null).toPromise();
    if (tableConfigResponse.responseCode === 0) {
      this.tableConfig = tableConfigResponse.data;
    }
  }

  get dataValid(): boolean {
    if (this.tableData === null || this.tableData === undefined || this.tableData.length === 0) return false;
    let hasError: boolean = true;
    if (this.tableData.length > 1) {
      hasError = this.tableData.reduce(function (a, b) { return a.isError || b.isError || false });
    } else if (this.tableData.length === 1) {
      hasError = this.tableData[0].isError;
    }
    return !hasError;
  }

  submit() {
    this.baseService.executeCommand(this.data.action.actionData.actionProc, { data: this.tableData })
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.dialogRef.close({data: this.tableData});
        }
      });
  }

  async onFileChange(ev) {
    let workBook = null;
    let jsonData = null;
    let dataString;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = async (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet, { raw: false });
        return initial[name];
        // return initial; -> This returns all sheets, we just support 1
      }, {});
      dataString = JSON.stringify(jsonData);
      const tableContentResponse = await this.baseService.executeCommand<any>(this.data.action.actionData.contentProc, { data: jsonData }).toPromise();
      if (tableContentResponse.responseCode === 0) {
        this.tableData = tableContentResponse.data;
      }
    }
    reader.readAsBinaryString(file);
    this.fileInput.nativeElement.value = ''; // Reset file input
  }
}
